
import React, { useState } from 'react';
import styles from '../../styles/home.module.css';
//import { useHistory } from 'react-router';
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router';

function Header() {
  const [show, setShow] = useState(false);

  const hamburgerHandler = () => {
    setShow(!show)
  }

  let showHamburger = null;
  if (show) {
    showHamburger = (
      <div className={styles.HamMenu}>
        <ul className={styles.UlHam}>
          <li className={styles.LiHam} onClick={hamburgerHandler}>
              <a id="ab" href="#about">O aplikaciji</a>
          </li>
          <li className={styles.LiHam} onClick={hamburgerHandler}>
              <a id="ex" href="#try">Kaj nudi</a>
          </li>
          <li className={styles.LiHam} onClick={hamburgerHandler}>
              <a id="ed" href="#new">Novosti</a>
          </li>
          <li className={styles.LiHam} onClick={hamburgerHandler}>
              <Link to="/Login" >Namizje</Link>
          </li>
        </ul>
      </div>
    )
  }

  const history = useHistory();

  const clickHandler = () => {
    history.push('/');
  }

  return (
    <React.Fragment>
      <header className={styles.Header}>
        <div className={styles.LogoDiv} onClick={clickHandler}>
          <img className={styles.LogoImg} src={require('../../icons/logoheart.png')} alt="Logo" />
          
          <img className={styles.LogoImg2} src={require('../../icons/zdravkoName.png')} alt="Logo" />
        </div>
        <nav className={styles.Nav}>
          <ul className={styles.Ul}>
            <li className={styles.Li}>
                <a className="" id="ab" href="#about">O aplikaciji</a>
            </li>
            <li className={styles.Li}>
                <a className="" id="ex" href="#try">Kaj nudi</a>
            </li>
            <li className={styles.Li}>
                <a className="" id="ed" href="#new">Novosti</a>
            </li>
            <li className={styles.Li}>
                <Link to="/Login" >Namizje</Link>
            </li>
          </ul>
        </nav>
        <div className={styles.HamDiv}
              onClick={hamburgerHandler}>
          <img className={styles.HamIcon} src={require('../../icons/hamburger.png')} alt="Hamburger icon" />
        </div>
        
      </header>
      {showHamburger}
    </React.Fragment>
  );
}

export default Header;
